import type { VariantProps } from "@gluestack-ui/nativewind-utils"
import React from "react"
import { textStyle } from "./styles"

type ITextProps = React.ComponentProps<"span"> & VariantProps<typeof textStyle>
type WebOnlyTextProps = ITextProps & {
  ellipsizeMode?: unknown
  numberOfLines?: unknown
  selectable?: unknown
}

const Text = React.forwardRef<React.ElementRef<"span">, ITextProps>(
  (
    {
      className,
      isTruncated,
      bold,
      underline,
      strikeThrough,
      size = "md",
      sub,
      italic,
      highlight,
      ellipsizeMode: _ellipsizeMode,
      numberOfLines: _numberOfLines,
      selectable: _selectable,
      ...props
    }: { className?: string } & WebOnlyTextProps,
    ref,
  ) => {
    return (
      <span
        className={textStyle({
          isTruncated,
          bold,
          underline,
          strikeThrough,
          size,
          sub,
          italic,
          highlight,
          class: className,
        })}
        {...props}
        ref={ref}
      />
    )
  },
)

Text.displayName = "Text"

export { Text }
